@if (showCard) {
  <div class="card job-card">
    <legend>
      <div class="flex-row">
        <div class="left">Custom Fields </div>
      </div>
    </legend>
    <ng-container *ngTemplateOutlet="fieldTemplate"></ng-container>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="fieldTemplate"></ng-container>
}



<ng-template #fieldTemplate>

  @if ((orderedMappings$ | async); as orderedMappings) {
    @if (!orderedMappings?.length) {
      @if (showEmptyMessage) {
        No custom fields available
      }
    } @else {
      <div [ngClass]="{fields: useFields, 'field-container': !useFields}">
        @for (mapping of orderedMappings; track mapping) {
          <ng-container [formGroup]="form">
            @if (getType(mapping) === CustomFieldType.Link) {
              @let isEdit = $editingLink()?.id === mapping.fieldId;
              <field [required]="$safeNavigationMigration(mapping?.required)" [label]="shouldShowLabels(mapping) ? mapping.name : null" (cancelClick)="cancelLink(null)" >
                <div class="custom-field-link-field" [ngClass]="{'link-field-edit':isEdit}" *fieldEditor>
              @if (isEdit && !(readonly || mapping.readonly)) {
                <w-link-field [formControlName]="mapping.fieldId" [required]="$safeNavigationMigration(mapping?.required)"></w-link-field>
                <div class="button-container">
                  <button class="btn field-button btn-primary" [disabled]="!form.get(mapping.fieldId).valid" (click)="saveLink(mapping.fieldId)">Save</button>
                  <button class="btn field-button" (click)="cancelLink(mapping.fieldId)">Cancel</button>
                </div>
              } @else {
                @let link = form.get(mapping.fieldId).value;
                @let invalid = $safeNavigationMigration(form.get(mapping.fieldId)?.invalid);
                <!-- {} Tarek's Technology - Correct the format-->
                <div class="link-readonly" [ngClass]="{'has-link':!!link?.url}">
                  @if (link?.url) {
                    <a class="link-value" [href]="link.url | linkHref" target="_blank" rel="noopener noreferrer">{{ link.text || link.url }}</a>
                    <i class="fa fa-copy link-action" title="Copy link" (click)="copyLink(link.url)"></i>
                    @if (!(readonly || mapping.readonly)) {
                      <i class="fa fa-pencil link-action" title="Edit" (click)="startEditLink(mapping.fieldId)"></i>
                    }
                  } @else {
                    @if (!(readonly || mapping.readonly)) {
                      <div class="not-set-box" [class.invalid]="invalid && !showLabels" (click)="startEditLink(mapping.fieldId)">Not Set</div>
                    } @else {
                      <span class="not-set" [class.invalid]="invalid && !showLabels">Not Set</span>
                    }
                  }
                </div>
              }
      </div>
      </field>
    }
    @else if(getType(mapping) !== CustomFieldType.Image){
      <field [readonly]="readonly || mapping.readonly" [required]="$safeNavigationMigration(mapping?.required)" [label]="shouldShowLabels(mapping) ? mapping.name : null" [mode]="editMode" [buttons]="getButtons(mapping.fieldId)" (buttonClick)="onButtonClick(mapping.fieldId, $event)" (cancelClick)="onCancelClick(mapping.fieldId)">
        <div class="prewrap" *fieldReadonly>
          @switch (getType(mapping)) {
            <!-- <employee-picker *ngSwitchCase="CustomFieldType.PickerEmployee" [multiple]="mapping?.field?.options?.multiple" [formControlName]="mapping.fieldId" [mode]="PickerMode.ReadOnly"></employee-picker> -->
            @default {
              {{ form.get(mapping.fieldId).value | customFieldValue:mapping.fieldId}}
            }
          }
        </div>
        <div class="value margin-bottom-5" *fieldEditor>
          @switch (getType(mapping)) {
            @case (CustomFieldType.Phone) {
              <input [formControlName]="mapping.fieldId" [pKeyFilter]="/[\d ()+\-]/" type="text" [placeholder]="'<' + mapping.name + '>'">
            }
            @case (CustomFieldType.Email) {
              <input [formControlName]="mapping.fieldId" [pKeyFilter]="'email'" type="email" [placeholder]="'<' + mapping.name + '>'">
            }
            @case (CustomFieldType.Number) {
              <input [formControlName]="mapping.fieldId" type="number" [min]="$safeNavigationMigration(mapping?.field?.options?.min)" [max]="$safeNavigationMigration(mapping?.field?.options?.max)" [placeholder]="'<' + mapping.name + '>'">
              @if (mapping?.field?.options?.min && mapping?.field?.options?.max) {
                <label>Must be between: ({{mapping?.field?.options?.min}} - {{mapping?.field?.options?.max}})</label>
              }
              @if (mapping?.field?.options?.min && !mapping?.field?.options?.max) {
                <label>Min: {{mapping?.field?.options?.min}}</label>
              }
              @if (mapping?.field?.options?.max && !mapping?.field?.options?.min) {
                <label>Max: {{mapping?.field?.options?.max}}</label>
              }
            }
            @case (CustomFieldType.Text) {
              <input [formControlName]="mapping.fieldId" type="text" [placeholder]="'<' + mapping.name + '>'">
            }
            @case (CustomFieldType.Note) {
              <textarea autosize rows="1" [formControlName]="mapping.fieldId" [placeholder]="'<' + mapping.name + '>'"></textarea>
            }
            @case (CustomFieldType.Boolean) {
              <switch [formControlName]="mapping.fieldId"></switch>
            }
            @case (CustomFieldType.Dropdown) {
              <ng-select bindLabel="value" bindValue="value" [groupBy]="mapping?.field?.options?.groups?.length > 1 ? 'group' : null" [groupValue] [items]="mapping.field | customFieldDrodownValues" [clearable]="true" [formControlName]="mapping.fieldId" [placeholder]="'<' + mapping.name + '>'" [hideSelected]="true"></ng-select>
            }
            @case (CustomFieldType.DropdownMulti) {
              <ng-select bindLabel="value" bindValue="value" [groupBy]="mapping?.field?.options?.groups?.length > 1 ? 'group' : null" [items]="mapping.field | customFieldDrodownValues" [multiple]="true" [clearable]="true" [formControlName]="mapping.fieldId" [placeholder]="'<' + mapping.name + '>'" [hideSelected]="true"></ng-select>
            }
            @case (CustomFieldType.Date) {
              <luxon-calendar appendTo="body" [defaultDate]="defaultDate" [dateFormat]="$safeNavigationMigration(tenantRegion?.dateFormat)" [showButtonBar]="true" [formControlName]="mapping.fieldId" [placeholder]="'<' + mapping.name + '>'"></luxon-calendar>
            }
            @case (CustomFieldType.DateTime) {
              @let zone = timezoneMap.get(mapping.fieldId);
                      <luxon-calendar appendTo="body" [zone]="zone" [defaultDate]="defaultDate" [dateFormat]="$safeNavigationMigration(tenantRegion?.dateFormat)" [showTime]="true" [showButtonBar]="true" [formControlName]="mapping.fieldId" [placeholder]="'<' + mapping.name + '>'"></luxon-calendar>
                    }
                    @case (CustomFieldType.Address) {
                <w-address [required]="mapping.required" [formControlName]="mapping.fieldId"></w-address>
              }
              <!-- <address [showLabel]="false" [showSitePicker]="false" [required]="mapping.required" *ngSwitchCase="CustomFieldType.Address" [formControlName]="mapping.fieldId"></address> -->
              <!-- <employee-picker *ngSwitchCase="CustomFieldType.PickerEmployee" [multiple]="mapping?.field?.options?.multiple" [formControlName]="mapping.fieldId" [placeholder]="'<' + mapping.name + '>'" appendTo="body"></employee-picker> -->
            }
        </div>
      </field>
    }
    @else{
      <field [required]="$safeNavigationMigration(mapping?.required)" [label]="shouldShowLabels(mapping) ? mapping.name : null">
        <upload-field *fieldEditor [multiple]="false" [readonly]="readonly || mapping.readonly" [formControl]="getFormControl(mapping.fieldId)" [hideAddRelated]="true" [allowedTypes]="UploadAllowedType.Images" (attachmentDeletedCanCancel)="attachmentDeleted(mapping.fieldId, $event)" (attachmentDeleted)="onImageRemoved(mapping.fieldId)" (attachmentUploaded)="attachmentUploaded(mapping.fieldId,$event)" />
      </field>
    }
    </ng-container>
  }
  </div>
}
}


</ng-template>